export const addProtocolToLink = (link: string) => {
    let newUrl;
    try {
      newUrl = new URL(link);
    }
    catch(e: any) { 
      if (e.message.toLowerCase().includes("invalid")) {
        newUrl = new URL("https://" + link);
      }
    }
    return newUrl?.toString();
}